const enquirePopup = {

    open: document.getElementById('jsOpenEquire') as HTMLElement,
    close: document.getElementById('jsCloseEnquire') as HTMLElement,
    overlay: document.getElementById('jsEnquireOverlay') as HTMLElement,
    popup: document.getElementById('jsEnquireForm') as HTMLElement,

    init() {
        this.openForm();
        this.closeForm();
        this.closeOverlay();
    },


    openForm() {
        this.open.addEventListener('click', () => {
            if(this.open.dataset.open === 'false') {
                this.open.dataset.open = 'true';
                this.popup.classList.add('activeClass');
                this.overlay.classList.add('activeClass');
                document.documentElement.style.overflow = 'hidden';
            } else {
                this.open.dataset.open = 'false';
                this.popup.classList.remove('activeClass');
                this.overlay.classList.remove('activeClass');
                document.documentElement.style.overflow = 'auto';
            }
        });
    },


    closeOverlay() {
        this.overlay.addEventListener('click', () => {
            this.overlay.classList.remove('activeClass');
            this.open.dataset.open = 'false';
            this.popup.classList.remove('activeClass');
            document.documentElement.style.overflow = 'auto';
        });
    },

    closeForm() {
        this.close.addEventListener('click', () => {
            this.overlay.classList.remove('activeClass');
            this.open.dataset.open = 'false';
            this.popup.classList.remove('activeClass'); 
            document.documentElement.style.overflow = 'auto';
        })
    },


}

export default enquirePopup;